import styles from './Tag.module.scss'

interface ITagInfoProps {
  id?: string
  name: string
  bgColor: string
  textColor: string
}

const Tag = ({ name, bgColor, textColor }: ITagInfoProps) => (
  <span
    className={`mb-2 rounded px-1.5 py-1 text-center text-xs font-medium md:px-2 xl:text-sm ${styles.tags}`}
    style={{ color: textColor, backgroundColor: bgColor }}>
    {name}
  </span>
)

const TagList = (tagData?: ITagInfoProps[]) =>
  tagData?.map(tag => (
    <Tag key={tag.id} name={tag.name} bgColor={tag.bgColor} textColor={tag.textColor} />
  ))

export default TagList
